const slidingCarousel = (postType) => (
    `... on ${postType}_Components_Components_SlidingCarousel {
        fieldGroupName
        title
        cta {
            target
            title
            url
        }
        items {
            title
            itemLink {
                target
                title
                url
            }
            image {
                altText
                title
                sizes(size: LARGE)
                sourceUrl(size: LARGE)
                srcSet(size: LARGE)
            }
            settings {
                enableRoundedImageCorners
                forceNativeImageSize
            }
        }
        settings {
            theme
            showComponentTitle
            componentTitle
            spacing
        }
    }`
);

export default slidingCarousel;
